import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var line_dashed_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(
  Path,
  {
    fillRule: "evenodd",
    d: "M5 11.25h3v1.5H5v-1.5zm5.5 0h3v1.5h-3v-1.5zm8.5 0h-3v1.5h3v-1.5z",
    clipRule: "evenodd"
  }
) });
export {
  line_dashed_default as default
};
//# sourceMappingURL=line-dashed.js.map
